import cashLogService from '@/views/CashLog/CashLogService';
import {
  APPLY_FILTERS,
  SET_ITEMS,
  FILTER_ITEMS,
  SET_TARGETING_ITEM,
  SET_SUMMARY,
  SET_APPEND,
  SET_LOADING,
  RESET
} from './types';

export default {
  applyFilter({ commit }, filters) {
    commit(APPLY_FILTERS, filters);
  },

  setAppend({ commit }, val) {
    commit(SET_APPEND, val);
  },

  async getCashLogList({ commit, state }, passiveFiltering = true) {
    if (state.isLoading) return;

    commit(SET_LOADING, true);

    if (passiveFiltering) {
      commit(SET_APPEND, (state.filters.page > 1));
      const { items, total } = await cashLogService.getCashLogList(state.filters);
      commit(SET_ITEMS, { items, total });
    }

    commit(FILTER_ITEMS);
    commit(SET_LOADING, false);
  },

  async getCashLogPendingList({ commit, state }) {
    const { items, total } = await cashLogService.getCashLogPendingList(state.filters);
    commit(SET_ITEMS, { items, total });
  },

  async getCashClosureList({ commit, state }) {
    const filters = {
      page: state.filters.page,
      pageSize: state.filters.pageSize,
    };
    const { items, total } = await cashLogService.getCashClosureList(filters);
    commit(SET_ITEMS, { items, total });
  },

  setTargetingItem({ commit }, { item }) {
    commit(SET_TARGETING_ITEM, { item });
  },

  async getSummary({ commit, state }) {
    if (state.filters.page === 1) {
      const summary = await cashLogService.getCashLogSummary(state.filters);
      commit(SET_SUMMARY, { summary });
    }
  },

  reset({ commit }) {
    commit(RESET);
  }
};
